import React, { useMemo } from 'react';

const StatisticsPanel = ({ data, type, stats = {} }) => {
  const computedStats = useMemo(() => {
    switch (type) {
      case 'class':
        const electiveClasses = data.filter(item => item.class_level >= 6);
        return {
          totalClasses: data.length,
          totalLevels: [...new Set(data.map(item => item.class_level))].length,
          electiveClasses: electiveClasses.length,
          classLevels: [...new Set(data.map(item => item.class_level))].sort()
        };
      case 'teacher':
        const allSubjects = data.flatMap(item => 
          Array.isArray(item.subjects) ? item.subjects : [item.subjects]
        );
        return {
          totalTeachers: data.length,
          subjects: [...new Set(allSubjects)],
          departments: [...new Set(allSubjects)].length
        };
      case 'student':
        const electiveStudents = data.filter(item => 
          item.elective_subjects && item.elective_subjects.length > 0
        );
        return {
          totalStudents: data.length,
          electiveStudents: electiveStudents.length,
          classes: [...new Set(data.map(item => item.saas_classes?.class_name).filter(Boolean))],
          totalClasses: [...new Set(data.map(item => item.saas_classes?.class_name).filter(Boolean))].length
        };
      default:
        return {};
    }
  }, [data, type]);

  const displayStats = { ...computedStats, ...stats };

  return (
    <div className="statistics-panel">
      <h3 className="statistics-title">📊 統計資訊</h3>
      <div className="statistics-grid">
        {Object.entries(displayStats).map(([key, value]) => (
          <div key={key} className="statistics-item">
            <div className="statistics-label">
              {key === 'totalClasses' && '班級總數'}
              {key === 'totalLevels' && '年級數量'}
              {key === 'electiveClasses' && '選修班級'}
              {key === 'classLevels' && '年級分布'}
              {key === 'totalTeachers' && '教師總數'}
              {key === 'subjects' && '任教科目'}
              {key === 'departments' && '科目數量'}
              {key === 'totalStudents' && '學生總數'}
              {key === 'electiveStudents' && '選修學生'}
              {key === 'classes' && '班級分布'}
              {key === 'totalClasses' && '班級數量'}
            </div>
            <div className="statistics-value">
              {Array.isArray(value) ? (
                <div className="statistics-array">
                  {value.slice(0, 3).join(', ')}
                  {value.length > 3 && `... 等${value.length}項`}
                </div>
              ) : (
                value
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatisticsPanel;
